export function formatCheckoutUrl(url) {
  return url.replace(
    process.env.NEXT_PUBLIC_MYSHOPIFY_DOMAIN,
    process.env.NEXT_PUBLIC_CHECKOUT_DOMAIN,
  )
}
